// src/components/CategorySection.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { collection, query, getDocs } from 'firebase/firestore';
import './main.css';

const CategorySection = () => {
  const [categories, setCategories] = useState([]);
  const [categoryImages, setCategoryImages] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        // Fetch all products to extract unique categories
        const productsRef = collection(db, 'products');
        const q = query(productsRef);
        const querySnapshot = await getDocs(q);
        
        // Extract all categories from products and store a representative image for each
        const allCategories = new Set();
        const imagesByCategory = {};
        
        querySnapshot.docs.forEach(doc => {
          const product = doc.data();
          if (product.category) {
            // Split categories by comma and trim whitespace
            const productCategories = product.category.split(',').map(cat => cat.trim());
            
            productCategories.forEach(cat => {
              if (cat) {
                allCategories.add(cat);
                // Store the first image we find for each category
                if (!imagesByCategory[cat] && product.image) {
                  imagesByCategory[cat] = product.image;
                }
              }
            });
          }
        });
        
        // Convert Set to Array and sort alphabetically
        const sortedCategories = Array.from(allCategories).sort();
        setCategories(sortedCategories);
        setCategoryImages(imagesByCategory);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching categories:', error);
        setIsLoading(false);
      }
    };

    fetchCategories();
  }, []);

  if (isLoading) {
    return <div className="loading-message">Loading Categories...</div>;
  }

  if (categories.length === 0) {
    return null; // Don't render anything if no categories found
  }

  return (
    <section className="categories" id="categories">
      <h1 className="heading"> Discover Our <span>Categories</span> </h1>
      <div className="category-container">
        {categories.map((category, index) => (
          <Link to={`/category/${encodeURIComponent(category)}`} key={index} className="category-box">
            {categoryImages[category] && (
              <div className="category-image">
                <img src={categoryImages[category]} alt={category} />
              </div>
            )}
            <div className="category-content">
              <h3>{category}</h3>
              <p>Browse our {category} products</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default CategorySection; 